// src/utils/formatters.ts
// ─────────────────────────────────────────────────────────────────────────────
// Canonical rounding + formatting helpers for all adviser-facing numbers.
// Imported by S2 screens and any downstream summary surfaces. Do not inline
// number formatting in components — add helpers here first.
// ─────────────────────────────────────────────────────────────────────────────

// Partial clients count as a full client (adviser plans for the whole person).
export const formatClients = (n: number): number => Math.ceil(n);

// Partial months count as a full month (adviser plans conservatively).
export const formatMonths = (n: number): number => Math.ceil(n);

// Achieved/current age rounds down — a 40.7-year-old is 40 until their birthday.
export const formatAge = (n: number): number => Math.floor(n);

// Target/planning age rounds up — a 40.7-year-old target reads as "by 41".
export const formatTargetAge = (n: number): number => Math.ceil(n);

// Percent to one decimal place. Input is a percent value, not a decimal —
// formatPercent(4.5) → "4.5%", not formatPercent(0.045).
export const formatPercent = (n: number): string => `${n.toFixed(1)}%`;

// Magnitude-based currency rounding:
//   ≥ £100,000 → round to nearest £1,000
//   ≥ £1,000   → round to nearest £100
//   <  £1,000  → round to nearest £10
// Preserves the sign of the input and uses en-GB locale thousands separators.
export function formatCurrency(n: number): string {
  const abs = Math.abs(n);
  if (abs >= 100000) return '£' + (Math.round(n / 1000) * 1000).toLocaleString();
  if (abs >= 1000)   return '£' + (Math.round(n / 100) * 100).toLocaleString();
  return '£' + (Math.round(n / 10) * 10).toLocaleString();
}
